import type {
  Size,
  WebflowCssProperties,
} from '@packages/systems/core/utils/WebflowCssSubset';
import type {PseudoStateKey} from '@packages/systems/core/utils/StyleTypes';

import {
  linkButtonColor,
  lightGreyBackground,
  lightGreyForeground,
  veryLightGreyBackground,
} from './Bootflow';
import {percent, px} from '@packages/systems/core/utils/WebflowCssSubset';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';

// Could this potentially be part of Bootflow?
export const buttonStyle: WebflowCssProperties = {
  backgroundColor: linkButtonColor,
  borderBottomLeftRadius: px(0),
  borderBottomRightRadius: px(0),
  borderTopLeftRadius: px(0),
  borderTopRightRadius: px(0),
  borderBottomWidth: px(0),
  borderLeftWidth: px(0),
  borderRightWidth: px(0),
  borderTopWidth: px(0),
  color: createRgbaColor('white'),
  cursor: 'pointer',
  paddingTop: px(9),
  paddingBottom: px(9),
  paddingLeft: px(15),
  paddingRight: px(15),
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',

  // Override default button styling in Safari et al
  appearance: 'none',
};

type PseudoNoPseudo = Partial<
  Record<PseudoStateKey | 'noPseudo', WebflowCssProperties>
>;
const noPseudoInputStyle = (width: Size): WebflowCssProperties => ({
  backgroundColor: veryLightGreyBackground,
  borderTopStyle: 'solid',
  borderTopWidth: px(1),
  borderTopColor: lightGreyBackground,
  borderRightStyle: 'solid',
  borderRightWidth: px(1),
  borderRightColor: lightGreyBackground,
  borderBottomStyle: 'solid',
  borderBottomWidth: px(1),
  borderBottomColor: lightGreyBackground,
  borderLeftStyle: 'solid',
  borderLeftWidth: px(1),
  borderLeftColor: lightGreyBackground,
  borderBottomLeftRadius: px(3),
  borderBottomRightRadius: px(3),
  borderTopLeftRadius: px(3),
  borderTopRightRadius: px(3),
  display: 'block',
  height: px(38),
  lineHeight: px(20),
  marginBottom: px(10),
  paddingTop: px(8),
  paddingRight: px(12),
  paddingBottom: px(8),
  paddingLeft: px(12),
  width,
});
const inputStyle = (noPseudo: WebflowCssProperties): PseudoNoPseudo => ({
  noPseudo,
  placeholder: {
    color: lightGreyForeground,
  },
  focus: {
    borderTopColor: linkButtonColor,
    borderRightColor: linkButtonColor,
    borderBottomColor: linkButtonColor,
    borderLeftColor: linkButtonColor,
    outlineStyle: 'none',
  },
});
export const quantityInputStyle = inputStyle({
  ...noPseudoInputStyle(px(60)),
  paddingRight: px(6),

  // Override default input styling in Safari et al
  appearance: 'none',
});
export const checkoutInputStyle = inputStyle({
  ...noPseudoInputStyle(percent(100)),
  marginBottom: px(16),

  // Override default input styling in Safari et al
  appearance: 'none',
});
export const mobileCheckoutInputStyle = {
  noPseudo: {
    // Prevents Mobile Safari zoom when focusing on inputs with less than 16px font size
    fontSize: px(16),
  },
} as const;

export const checkoutTextAreaStyle = inputStyle({
  paddingTop: px(8),
  paddingRight: px(12),
  paddingBottom: px(8),
  paddingLeft: px(12),
  backgroundColor: veryLightGreyBackground,
  borderTopStyle: 'solid',
  borderTopWidth: px(1),
  borderTopColor: lightGreyBackground,
  borderRightStyle: 'solid',
  borderRightWidth: px(1),
  borderRightColor: lightGreyBackground,
  borderBottomStyle: 'solid',
  borderBottomWidth: px(1),
  borderBottomColor: lightGreyBackground,
  borderLeftStyle: 'solid',
  borderLeftWidth: px(1),
  borderLeftColor: lightGreyBackground,
  borderBottomLeftRadius: px(3),
  borderBottomRightRadius: px(3),
  borderTopLeftRadius: px(3),
  borderTopRightRadius: px(3),
  marginBottom: px(16),
  height: px(76),
  width: percent(100),
});
